import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export function AgentAccountCard() {
  const [account, setAccount] = useState(null);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/agent").then((r) => setAccount(r.data)).catch(() => setAccount(false));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("La password deve avere almeno 8 caratteri");
    if (password !== confirm) return toast.error("Le due password non coincidono");
    setSaving(true);
    try {
      await api.put("/admin/agent/password", { password });
      toast.success("Password agente aggiornata: l'agente è stato disconnesso");
      setPassword("");
      setConfirm("");
      load();
    } catch (err) {
      toast.error(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || "Errore aggiornamento password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="tm-card p-6 max-w-xl" data-testid="agent-account-card">
      <div className="tm-tag inline-block mb-3">Accesso agente</div>
      <h3 className="font-heading text-2xl text-white tracking-tighter mb-1" data-testid="agent-email">
        {account ? account.email : account === false ? "Account non trovato" : "Caricamento…"}
      </h3>
      <p className="text-slate-400 text-sm mb-6">
        L&apos;agente vede tutto ciò che vede un cliente e in più può consultare i listini prezzi.
        {account?.password_changed_at && (
          <> Ultimo cambio password: {new Date(account.password_changed_at).toLocaleString("it-IT")}.</>
        )}
      </p>
      <form onSubmit={submit} className="space-y-4">
        <div>
          <label className="tm-label">Nuova password</label>
          <input
            type={show ? "text" : "password"}
            className="tm-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            data-testid="agent-password-input"
          />
        </div>
        <div>
          <label className="tm-label">Ripeti password</label>
          <input
            type={show ? "text" : "password"}
            className="tm-input"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            data-testid="agent-password-confirm"
          />
        </div>
        <label className="flex items-center gap-2 text-sm text-slate-400 cursor-pointer">
          <input type="checkbox" checked={show} onChange={(e) => setShow(e.target.checked)} data-testid="agent-password-show" />
          Mostra password
        </label>
        <p className="text-xs text-slate-500">Dopo il cambio, chi è collegato come agente viene disconnesso e deve rientrare con la nuova password.</p>
        <button type="submit" disabled={saving || !account} className="tm-btn-primary disabled:opacity-50" data-testid="agent-password-save">
          {saving ? "Salvo..." : "Cambia password agente"}
        </button>
      </form>
    </div>
  );
}
